export const CAST_LIST = [
  {
    id : 1,
    castId: 'bOanp5uBfnRXpfs70YlmKec3XtT2',
    name : "エルメス・ディアーナ",
    info : ""
  },
  {
    id : 3,
    castId: '7x8A8AAmGtPaJSOnR2WAXHsg6f13',
    name : "ニーナ・ファリーダ",
    info : ""
  }
]
